module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Unexpected Endings")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#fairground-attractions"
    }
  }, [_vm._v("Fairground Attractions")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#release"
    }
  }, [_vm._v("Release")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#on-the-town"
    }
  }, [_vm._v("On the Town")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#baton"
    }
  }, [_vm._v("Baton")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#hollow"
    }
  }, [_vm._v("Hollow")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#finding"
    }
  }, [_vm._v("Finding")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#aesops-warning"
    }
  }, [_vm._v("Aesop’s Warning")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#hidden-gems",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hidden Gems")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#before-the-storm",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Before the Storm")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#turntable",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turntable")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#ruminations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ruminations")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#turning-points",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turning Points")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#dirty-linen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dirty Linen")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#azrael",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Azrael")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#a-tale-of-two-ales",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Tale of Two Ales")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#cave-daemonium",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cave Daemonium")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#under-the-surface",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Under the Surface")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#random-acts-of-kindness",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Random Acts of Kindness")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#gaia",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gaia")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#shadows",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shadows")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#not-as-we-know-it",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Not as We Know It")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#light-and-dark",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Light and Dark")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#the-wimpire",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wimpire")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#full-circle",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Full Circle")])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#echoes-from-the-twelfth",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Echoes from the Twelfth")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#the-shelter",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Shelter")])]), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#wild-creatures",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wild Creatures")])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#midsummers-nightmare",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Midsummer’s Nightmare")])]), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#dark-matters",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dark Matters")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-246b895e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0